/**
 * @generated SignedSource<<34212b5cf26a5eae6f68b431151b1b3a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GroupMembersScreen_rootRef$data = {
  readonly group: {
    readonly id: string;
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"GroupMembersList_groupRef" | "RefreshSlug">;
  } | null | undefined;
  readonly " $fragmentType": "GroupMembersScreen_rootRef";
};
export type GroupMembersScreen_rootRef$key = {
  readonly " $data"?: GroupMembersScreen_rootRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"GroupMembersScreen_rootRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "slug"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "GroupMembersScreen_rootRef",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "slug",
          "variableName": "slug"
        }
      ],
      "concreteType": "Group",
      "kind": "LinkedField",
      "name": "group",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "RefreshSlug"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "GroupMembersList_groupRef"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Root",
  "abstractKey": null
};

(node as any).hash = "6cc5477a036f82ed80d2b647662ac92b";

export default node;
